import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import AllCustomers from './AllCustomers';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, customers, totalPage, currentPage, customerOverview,
  } = state.customer;
  return {
    isLoading,
    customers,
    totalPage,
    currentPage,
    customerOverview,
  };
}

const Styled = withStyles(styles)(AllCustomers);

export default connect(
  mapStateToProps,
)(Styled);
